import {
  GET_PRICE_PREVIEW_REQUEST,
  GET_PRICE_PREVIEW_SUCCESS,
  GET_PRICE_PREVIEW_FAILURE,
  RESET_PRICE_PREVIEW
} from 'bento-ordering/menus/constants/actionTypes';

import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import getGroupOrderQueryParam from 'bento-ordering/base/utils/getGroupOrderQueryParam';
import { getMenuItemPricePreviewEndpoint } from 'bento-ordering/base/constants/endpoints';

/**
 * see the product price preview of a item.
 * payload - required_fields
 */
export const getProductPricePreview = (id, payload) => (dispatch, getState) => {
  const state = getState();
  const endpoint = getMenuItemPricePreviewEndpoint(id);
  const queryParams = getGroupOrderQueryParam(state);

  return dispatch(
    apiAction(
      endpoint,
      'POST',
      [
        GET_PRICE_PREVIEW_REQUEST,
        GET_PRICE_PREVIEW_SUCCESS,
        GET_PRICE_PREVIEW_FAILURE
      ],
      payload,
      queryParams
    )
  );
};

export const resetProductPreview = () => {
  return {
    type: RESET_PRICE_PREVIEW
  };
};
